export default {"src":"/_next/static/media/gin.1367cbe9.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};